import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard/Dashboard';
import MatchManager from './components/MatchManager/MatchManager';
import ScoreController from './components/ScoreController/ScoreController';
import OddsViewer from './components/OddsViewer/OddsViewer';
import Login from './pages/Login';
import './App.css';
import { fetchCsrfToken } from './utils/axiosConfig';

const NavBar = () => {
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <nav className="navbar">
      <h1>Cricket Betting System</h1>
      <div className="nav-links">
        <Link to="/">Dashboard</Link>
        <Link to="/matches">Manage Matches</Link>
        <Link to="/score">Score Controller</Link>
        <Link to="/odds">Live Odds</Link>
        <button onClick={logout} className="logout-btn">Logout</button>
      </div>
    </nav>
  );
};

function App() {
  useEffect(() => {
    fetchCsrfToken();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <NavBar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/matches" element={
              <ProtectedRoute>
                <MatchManager />
              </ProtectedRoute>
            } />
            <Route path="/score" element={
              <ProtectedRoute>
                <ScoreController />
              </ProtectedRoute>
            } />
            <Route path="/odds" element={
              <ProtectedRoute>
                <OddsViewer />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;